<section class="section breadcrumbs-custom">
    <div class="breadcrumbs-custom-main bg-image bg-candidatelist">
        <div class="container">
            <h3 id="textInImage" class="breadcrumbs-custom-title">Υποψήφιοι</h3>
        </div>
    </div>
    <div class="breadcrumbs-custom-aside">
        <div class="container">
            <ul class="breadcrumbs-custom-path">
                <li><a routerLink="/">Αρχική</a></li>
                <li class="active">Υποψήφιοι</li>
            </ul>
        </div>
    </div>
</section>

<section class="section-md">
    <div *ngIf="candidatesData" class="container">
        <form (ngSubmit)="getCandidateFilteredList()" [formGroup]="candidatesSearchForm">
            <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-4">
                    <select (change)="onChange($event)" formControlName="sortBy" name="candidates" class="custom-select margin-select">
                        <option value="firstName" selected>Αλφαβητικά</option>
                        <option value="creationDate">Προστεθηκαν Πρόσφατα</option>
                    </select>

                    <div class="margin-p" *ngIf="numberOfCandidates>0; else candidatesNotFound">
                        <p>Βρέθηκαν {{numberOfCandidates}} προφίλ υποψηφίων</p>
                    </div>

                    <ng-template #candidatesNotFound>
                        <div class="margin-p">
                            <p>Δεν βρέθηκαν αποτελέσματα.</p>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div class="row row-50 flex-sm-row-reverse flex-lg-row-reverse flex-md-row-reverse">
                <!-- search with filters -->
                <div class="col-md-4 col-xs-12 col-sm-6">
                    <div class="row row-30">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-12">
                                    <p class="heading-10">φιλτρα αναζητησης</p>
                                </div>
                                <div class="row nomargin">
                                    <div class="col-md-12">
                                        <button *ngIf="isFiltered" class="btn btn-link" type="reset" (click)="discardfilters()"> Ακύρωση όλων</button>
                                    </div>
                                    <hr>
                                </div>
                            </div>
                            <br />

                            <!-- keywords -->
                            <div>
                                <label for="keywords" class="heading-8">λεξεις κλειδια</label>
                                <hr>
                                <br />
                                <div class="input-group mb-3">

                                    <input formControlName="keywords" style="height: calc(3rem + 2px); font-size: 0.9rem" type="text" class="form-control" placeholder="πχ. Software Engineer" id="keywords">
                                    <div class="input-group-prepend">
                                        <button type="submit" class="input-group-text searchIcon"><span
                                                class="icon fl-bigmug-line-search74"></span></button>
                                    </div>
                                </div>
                                <br />
                            </div>

                            <!-- education level -->
                            <div>
                                <p class="heading-8">βαθμιδα εκπαιδευσης</p>
                                <hr>
                                <ul class="list list-xs">
                                    <li>
                                        <div class="job_listing_checkbox">
                                            <div *ngFor="let data of types; let i=index">
                                                <label class="checkBoxContainer">
                                                    <input class="checkBoxInputs" type="checkbox"
                                                        [checked]="data.selected" [value]="data.id"
                                                        (change)="onCheckboxChange($event)" /> {{data.text}} <span
                                                        class="count-filters"
                                                        *ngIf="filters.educationLevel[data.id]; else zeroResults;">({{filters.educationLevel[data.id]}})</span>
                                                    <span class="checkmark"></span>

                                                </label>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <br />
                            </div>

                            <!-- years_of_work_experience -->
                            <div>
                                <p class="heading-8">προϋπηρεσια</p>
                                <hr>
                                <ul class="list list-xs">
                                    <li>
                                        <label class="job_listing_checkbox checkbox_info radioContainer">
                                            <input name="yearsOfWorkExperience" value="1" type="radio"
                                                (change)="getYearsOfWorkExperience($event.target.value, firstPage)"
                                                formControlName="yearsOfWorkExperience"> έως 3 έτη <span
                                                class="count-filters"
                                                *ngIf="filters.yearsOfWorkExperience['0to3']; else zeroResults">({{filters.yearsOfWorkExperience['0to3']}})</span>
                                            <span class="radiomark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label class="job_listing_checkbox checkbox_info  radioContainer">
                                            <input name="yearsOfWorkExperience" value="2" type="radio"
                                                (change)="getYearsOfWorkExperience($event.target.value, firstPage)"
                                                formControlName="yearsOfWorkExperience"> 4 - 6 έτη <span
                                                class="count-filters"
                                                *ngIf="filters.yearsOfWorkExperience['4to6']; else zeroResults">({{filters.yearsOfWorkExperience['4to6']}})</span>
                                            <span class="radiomark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label class="job_listing_checkbox checkbox_info  radioContainer">
                                            <input name="yearsOfWorkExperience" value="3" type="radio"
                                                (change)="getYearsOfWorkExperience($event.target.value, firstPage)"
                                                formControlName="yearsOfWorkExperience"> 7 έτη και άνω <span
                                                class="count-filters"
                                                *ngIf="filters.yearsOfWorkExperience['greaterThan6']; else zeroResults">({{filters.yearsOfWorkExperience['greaterThan6']}})</span>
                                            <span class="radiomark"></span>
                                        </label>
                                    </li>

                                    <br />
                                </ul>
                            </div>

                            <ng-template #zeroResults>
                                <span class="count-filters">(0)</span>
                            </ng-template>

                        </div>
                    </div>
                </div>

                <!-- list of candidates -->
                <div class="col-lg-8 col-sm-6 col-md-8 col-xs-12 col-container">
                    <div class="row row-40">
                        <div *ngFor="let candidate of candidatesData" class="col profile-classic">
                            <a [routerLink]="['/candidate/profile', candidate.keycloakId]">
                                <figure *ngIf="candidate.image" class="profile-classic-figure">
                                    <img class="myImage profile-classic-image" src="{{candidate.image}}" alt="" />
                                </figure>
                                <figure *ngIf="!candidate.image" class="profile-classic-figure">
                                    <img class="profile-classic-image myImage" src="https://upload.wikimedia.org/wikipedia/commons/7/7e/Circle-icons-profile.svg" alt="" />
                                </figure>
                            </a>
                            <div class="profile-classic-main">
                                <div class="row">
                                    <a [routerLink]="['/candidate/profile', candidate.keycloakId]">
                                        <div class="col-sm-12">
                                            <h5 style="font-size: 22px; word-break: keep-all;overflow-wrap: break-word;" class="profile-classic-name">{{candidate.firstName}} {{candidate.lastName}}
                                            </h5>
                                            <h6 *ngIf="candidate.headline" style="color:#1087eb;" class="profile-classic-name">{{candidate.headline}} </h6>
                                            <h6 *ngIf="!candidate.headline" style="color:#1087eb;" class="profile-classic-name">-</h6>
                                        </div>
                                    </a>
                                </div>
                                <ul class="profile-classic-list">
                                    <div class="anchors">
                                        <li *ngIf="candidate.linkedInUrl"><a [href]="candidate.linkedInUrl"><span
                                                    class="icon mdi mdi-linkedin-box"></span>
                                                {{candidate.linkedInUrl}}</a></li>
                                    </div>
                                    <div class="anchors">
                                        <li><span class="icon mdi mdi-email-outline"></span><a href="mailto:{{candidate.email}}"> {{candidate.email}}</a></li>
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <br />
                    <!-- Pagination-->
                    <app-pagination-bs [initialPage]="currentPage + 1" [items]="candidates.candidateSearchResults" [pageSize]="pageSize" (changePage)="onChangePage($event)"></app-pagination-bs>
                </div>
            </div>
        </form>
    </div>
</section>